// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Delete = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <path
        className='cls-3'
        d='M38.5,11.5l-1.7,25.44c0,3.03-2.22,5.52-4.93,5.52h-15.74c-2.73,0-4.93-2.47-4.93-5.52l-1.7-25.44h29Z'
      />
      <line x1='19.21' y1='18.83' x2='19.21' y2='34.83' />
      <line x1='28.79' y1='18.83' x2='28.79' y2='34.83' />
      <path d='M29.73,9.25v2.25h-12.17v-2.25c0-2.04,1.28-3.71,2.83-3.71h6.51c1.56,0,2.83,1.67,2.83,3.71Z' />
      <line x1='5.25' y1='11.5' x2='42.75' y2='11.5' />
    </svg>
  );
};
